import React from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const NavigationBreadcrumbs = ({ customBreadcrumbs = null }) => {
  const location = useLocation();

  const routeMap = {
    '/login-authentication': 'Authentication & MFA',
    '/system-administration-dashboard': 'System Administration',
    '/client-and-site-management': 'Client & Site Management',
    '/inspection-management': 'Inspection Management',
    '/equipment-inventory-management': 'Equipment Inventory',
    '/inspection-planning-and-scheduling': 'Inspection Planning',
    '/work-order-management-and-tracking': 'Work Orders',
    '/mobile-inspection-interface': 'Mobile Inspection',
    '/pdf-template-management-and-generation': 'PDF Templates',
    '/compliance-analytics-and-reporting': 'Compliance Analytics',
    '/user-management-and-role-administration': 'User Management',
    '/client-portal-dashboard': 'Client Portal',
    '/system-integration-and-api-management': 'System Integration',
  };

  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) {
      return customBreadcrumbs;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Dashboard', path: '/' }];

    let currentPath = '';
    pathSegments?.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label = routeMap?.[currentPath] || segment?.replace(/-/g, ' ')?.replace(/\b\w/g, l => l?.toUpperCase());
      
      breadcrumbs?.push({
        label,
        path: currentPath,
        isLast: index === pathSegments?.length - 1
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleNavigation = (path) => {
    if (path !== location?.pathname) {
      window.location.href = path;
    }
  };

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {breadcrumbs?.map((crumb, index) => (
          <li key={crumb?.path} className="flex items-center">
            {index > 0 && (
              <Icon name="ChevronRight" size={14} className="mx-2 text-muted-foreground/60" />
            )}
            
            {crumb?.isLast ? (
              <span className="font-medium text-foreground truncate max-w-xs sm:max-w-none">
                {crumb?.label}
              </span>
            ) : (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleNavigation(crumb?.path)}
                className="h-auto p-0 font-normal text-muted-foreground hover:text-foreground transition-micro"
              >
                <span className="truncate max-w-24 sm:max-w-none">
                  {crumb?.label}
                </span>
              </Button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default NavigationBreadcrumbs;